import { Tab } from 'react-bootstrap';
import React from 'react';
import app from 'srcJs/App';
import { Else, If, Then } from 'react-if';
import { IntercomTriggerIcon } from 'components/intercom/components/IntercomTriggerIcon';

var SupportContent = function SupportContent(_ref) {
  var supportInfo = _ref.supportInfo;

  if (!supportInfo) {
    return null;
  }

  return /*#__PURE__*/React.createElement(Tab.Pane, {
    eventKey: "support"
  }, /*#__PURE__*/React.createElement("div", {
    className: "fs-22 mb-4 pb-3"
  }, app.tForReact('base_menu', 'Help Center')), /*#__PURE__*/React.createElement("ul", {
    className: "desktop-nav-list desktop-nav-list--margin-lg"
  }, /*#__PURE__*/React.createElement("li", null, app.tForReact('base_menu', 'Support Chat'), /*#__PURE__*/React.createElement(If, {
    condition: supportInfo.isDisplayIntercom
  }, /*#__PURE__*/React.createElement(Then, null, /*#__PURE__*/React.createElement(IntercomTriggerIcon, {
    additionalClassName: "mt-2"
  })), /*#__PURE__*/React.createElement(Else, null, /*#__PURE__*/React.createElement("div", null, supportInfo.scheduleChatWeekdays), /*#__PURE__*/React.createElement("div", null, supportInfo.scheduleChatWeekend)))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("div", null, app.tForReact('base_menu', 'Mail')), /*#__PURE__*/React.createElement("a", {
    href: "mailto:".concat(supportInfo.email),
    target: "_blank",
    rel: "noreferrer"
  }, supportInfo.email))));
};

export { SupportContent };